// Centralized version variables for UI
// Prefer a single source REACT_APP_VERSION; fall back to legacy vars if present

export const VERSION = process.env.REACT_APP_VERSION
  || process.env.REACT_APP_APP_VERSION
  || process.env.REACT_APP_AGENT_VERSION
  || 'dev';

export const APP_VERSION = process.env.REACT_APP_APP_VERSION
  || process.env.REACT_APP_VERSION
  || 'dev';

export const AGENT_VERSION = process.env.REACT_APP_AGENT_VERSION
  || process.env.REACT_APP_VERSION
  || APP_VERSION
  || 'dev';
